import http from "./http"
export function getQuanmaiApi(url, data) {
    return http.prototype.Get("/quanmaiapi" + url, data, true);
}
export function postQuanmaiApi(url, data) {
    return http.prototype.Post("/quanmaiapi" + url, data);
}
export function getShopApi(url, data) {
    return http.prototype.Get("/shopapi" + url, data);
}
export function postShopApi(url, data) {
    return http.prototype.Post("/shopapi" + url, data);
}
export function getUserApi(url, data) {
    return http.prototype.Get("/userapi" + url, data);
}
export function postUserApi(url, data) {
    return http.prototype.Post("/userapi" + url, data);
}
export function putUserApi(url, data) {
    return http.prototype.Put("/userapi" + url, data);
}
export function getFile(url, data) {
    return http.prototype.Get("/fileapi" + url, data);
}
export function getCommonApi(url, data) {
    return http.prototype.Get("/commonapi" + url, data);
}
export function postCommonApi(url, data) {
    return http.prototype.Post("/commonapi" + url, data);
}


// WEBPACK FOOTER //
// ./src/service/proxy.js